import React, { Component } from 'react';
import axios from 'axios';
import './comments.css';
import Auth from './auth.component';

class Comments extends Component {

    state = {
        url: window.location.href,
        title: 'Alsoug Moments',
        description: '',
        auth: false,
        comments: []
    }

    constructor(props) {
        super(props);

        this.addComment = this.addComment.bind(this);
        this.renderComment = this.renderComment.bind(this);
        this.loginCallBack = this.loginCallBack.bind(this);
        this.checkAuth = this.checkAuth.bind(this);
    }

    componentDidMount() {
        this.getComments()
        this.checkAuth();
    }

    getComments() {
        axios.get(`https://www.alsoug.com/adverts/${this.props.id}/listComments`, {
            headers: {
                ApiKey: 'd5ab8dc7ef67ca92e41d730982c5c602',
                Authorization: localStorage.getItem('token')
            }
        }).then(res => {
            if (res.data.status === 200 || res.data.status.code === 200 || res.data.status.status !== 0) {
                this.setState({
                    comments: res.data.data
                })
                console.log(res)
            }
        })
    }

    checkAuth() {
        const token = localStorage.getItem('token');
        if (!token) {
            this.setState({
                auth: false
            })
            return false;
        }
        this.setState({
            auth: true
        })
        return true;
    }

    addComment(ev) {
        ev.preventDefault();

        let auth = this.checkAuth();

        if (!auth) {
            return false;
        }

        let data = new FormData();
        let inputs = this.refs.commentForm.querySelectorAll('[name]')

        if (inputs) {
            inputs.forEach(input => {
                data.append(input.name, input.value);
            })
        }

        axios.post('https://www.alsoug.com/adverts/doAddComments', data, {
            headers: {
                ApiKey: 'd5ab8dc7ef67ca92e41d730982c5c602',
                Authorization: localStorage.getItem('token')
            }
        }).then(res => {
            this.getComments()
        })

        return false;
    }

    renderAddComment() {
        return (
            <form className='add-comment' onSubmit={this.addComment} ref="commentForm">
                <input name="comment_identifier" type='hidden' value={this.props.id} />
                <input name="is_blog_post_comment" type='hidden' value='1' />
                <input name="parent" type='hidden' value='0' />
                <input className="input" name="comment" type='text' placeholder="اكتب تعليق مناسب" />
                <button className="button" type="submit">ضيف تعليق</button>
            </form>
        )
    }

    renderComment(comment) {
        if (!comment.comment_approved) {
            return;
        }
        return (
            <div className="comment" key={comment.id}>
                <header>
                    <small>{comment.display_name}</small>
                    <small>{comment.created_at}</small>
                </header>
                <p>{comment.comment_content}</p>
            </div>
        )
    }

    loginCallBack(auth) {
        this.checkAuth()
    }

    render() {
        return (
            <div className="comments">
                <img className="logo" src="/logo.png" />
                {this.state.auth ? this.renderAddComment() : <Auth loginCallBack={this.loginCallBack} />}
                {this.state.comments.length 
                ? 
                    <div>
                        <h3>التعليقات:</h3>
                        {this.state.comments.map(this.renderComment)}
                    </div> 
                : 
                    <h3 className="emptyMessage">لا يوجد تعليقات <br /> كون اول من يضيف تعليق على الصورة</h3>
                }
            </div>
        );
    }
}

export default Comments;
